import React from "react";
import {
  AlertDialog,
  AlertDialogClose,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogPopup,
  AlertDialogTitle,
  Box,
  Button,
  Input,
} from "@salestrak/ui";

interface RenameIssueDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  value: string;
  onValueChange: (value: string) => void;
  onConfirm: () => void;
}

/**
 * Rename prompt for an issue. One AlertDialog at every breakpoint —
 * bottom-stick covers the mobile presentation, so there is no sheet fork.
 */
export function RenameIssueDialog({
  open,
  onOpenChange,
  value,
  onValueChange,
  onConfirm,
}: RenameIssueDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogPopup>
        <Box
          as="form"
          onSubmit={(e) => {
            e.preventDefault();
            if (value.trim()) onConfirm();
          }}
        >
          <AlertDialogHeader>
            <AlertDialogTitle>Rename project</AlertDialogTitle>
            <AlertDialogDescription>
              Enter a new name for this project.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <Box paddingX="lg" paddingBottom="md">
            <Input
              aria-label="Project name"
              value={value}
              onChange={(e) => onValueChange(e.target.value)}
              autoFocus
            />
          </Box>
          <AlertDialogFooter>
            <AlertDialogClose render={<Button variant="outline" />}>
              Cancel
            </AlertDialogClose>
            <Button type="submit" disabled={!value.trim()}>
              Rename
            </Button>
          </AlertDialogFooter>
        </Box>
      </AlertDialogPopup>
    </AlertDialog>
  );
}
